// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1U2lf";
var _4 = "wrapper_pointer-2j3Kh";
var _5 = "active-3MRZ7";
var _6 = "selected-3I5dm";
var _7 = "icon-3_zk-";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "wrapper_pointer", _5 as "active", _6 as "selected", _7 as "icon" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "wrapper_pointer": _4, "active": _5, "selected": _6, "icon": _7 }
